import { RechtSeitenRahmen } from "@/components/recht/RechtSeitenRahmen";
import { ErklaerungsBestaetigungAnzeige } from "@/components/recht/ErklaerungsBestaetigung";
import { WIDERRUF_PFADE } from "@/lib/vertragErklaerung";

// Bestätigung nach „Widerruf bestätigen“ (Sitzung „Aufräumen“, 14.10.2026), nie in Google.
const VertragBestaetigung = () => (
  <RechtSeitenRahmen
    titel="Widerruf eingegangen"
    beschreibung="Eingangsbestätigung mit Datum und Uhrzeit."
    pfad={WIDERRUF_PFADE.bestaetigung}
    noindex
  >
    <ErklaerungsBestaetigungAnzeige />
  </RechtSeitenRahmen>
);

export default VertragBestaetigung;
